export default "__VITE_ASSET__DR11X0Mx__"